import React, { useState } from 'react';
import EmbeddModalForm from '../ModalBlock/ModalForm/EmbeddModalForm';
import PrecourseForm from '../Forms/SpecificForms/PrecourseForm';

const formData = {
  title: 'Остались вопросы',
  message: 'Оставьте контактные данные и с вами свяжется куратор',
  sentContent: {
    title: 'Данные успешно отправлены!',
    message: 'В ближайшее время с вами свяжется куратор',
  },
};

function PrecourseConsultationModal({
  extraLeadData,
  ymSubmitEventType,
  ymSubmitExtraEventType,
  myTargetEvent,
}) {
  const [isFormSent, setIsFormSent] = useState(false);
  const [isError, setIsError] = useState(false);

  return (
    <EmbeddModalForm {...formData} isSent={isFormSent} isError={isError}>
      <PrecourseForm
        setIsSent={setIsFormSent}
        setIsError={setIsError}
        extraLeadData={extraLeadData}
        ymSubmitEventType={ymSubmitEventType}
        ymSubmitExtraEventType={ymSubmitExtraEventType}
        myTargetSubmitEventType={myTargetEvent}
      />
    </EmbeddModalForm>
  );
}

export default PrecourseConsultationModal;
